export default function (array) {
  return array.length === 1 ? array[0] : array.join(' ')
}



// WEBPACK FOOTER //
// ./node_modules/vux/src/filters/array2String.js